import { render, staticRenderFns } from "./PayrollMovementGroupDetail.vue?vue&type=template&id=473a119e&scoped=true"
import script from "./PayrollMovementGroupDetail.vue?vue&type=script&lang=js"
export * from "./PayrollMovementGroupDetail.vue?vue&type=script&lang=js"
import style0 from "./PayrollMovementGroupDetail.vue?vue&type=style&index=0&id=473a119e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473a119e",
  null
  
)

export default component.exports